import { wrapAsDerivedFromMeasurementsConfig as wrap } from 'Components/Worksheets/Core/Helpers/configHelpers';

const getDerivedFromMeasurementsConfigForPortionMassMeasurement = (prefix: string) => ({
  [`${prefix}.WetMass`]: wrap([`${prefix}.TareMass`, `${prefix}.TareAndWetMass`]),
  [`${prefix}.DryMass`]: wrap([`${prefix}.TareMass`, `${prefix}.TareAndDryMass`]),
});

const getDerivedFromMeasurementsConfigForPortionSieving = (prefix: string) => ({
  [`${prefix}.Records.IndividualMassRetainedReadings`]: wrap([`${prefix}.Records.MassRetainedReadings`]),
  [`${prefix}.Records.IndividualMassRetained`]: wrap([`${prefix}.Records.MassRetainedReadings`]),
  [`${prefix}.Records.CumulativeMassRetained`]: wrap([`${prefix}.Records.MassRetainedReadings`]),
  [`${prefix}.CumulativePanMassRetained`]: wrap([
    `${prefix}.Records.MassRetainedReadings`,
    `${prefix}.PanMassRetainedReading`,
  ]),
  [`${prefix}.IndividualPanMassRetained`]: wrap([
    `${prefix}.Records.MassRetainedReadings`,
    `${prefix}.PanMassRetainedReading`,
  ]),
});

export { getDerivedFromMeasurementsConfigForPortionMassMeasurement, getDerivedFromMeasurementsConfigForPortionSieving };
